<template>
    <bottom-sheet v-model="shows" v-bind="{ title }" fullscreen persistent width="720" maxWidth="100%">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents h-100">
            <v-sheet style="flex: 1 1 auto; overflow-x: hidden; overflow-y: auto" class="scroll-primary">
                <vertical-form-table v-model="form" v-bind="{ items }" class="mb-20 mb-lg-40 mx-8" @input="emit" />
            </v-sheet>
            <div class="v-btn-group flex-wrap">
                <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" v-bind="{ loading }" @click="shows = false"><span class="grey-6--text">취소하기</span></v-btn>
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" v-bind="{ loading }" @click="save">
                    <template v-if="isCreate">
                        <span> 생성하기 </span>
                    </template>
                    <template v-else>
                        <span> 수정하기 </span>
                    </template>
                </v-btn>
            </div>
        </v-layout>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { attrs_input, attrs_switch } from "@/assets/variables/attrs";
import { initAttendanceCode } from "@/store/attendance";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

export default {
    components: {
        BottomSheet,
        VerticalFormTable,
    },
    props: {
        value: { type: Object, default: initAttendanceCode },
    },
    data: () => ({
        form: initAttendanceCode(),

        shows: false,
        loading: false,
    }),
    computed: {
        isCreate() {
            return !this.value?._id;
        },
        title() {
            let title = "근로계약 출근QR";
            if (this.isCreate) title += " 생성하기";
            else title += " 수정하기";
            return title;
        },
        items() {
            return [
                {
                    key: "name",
                    term: "명칭",
                    type: "text",
                    required: true,
                    ...attrs_input,
                },
                {
                    key: "uses",
                    term: "사용여부",
                    type: "switch",
                    required: true,
                    label: this.form.uses ? "사용" : "안함",
                    ...attrs_switch,
                },
            ];
        },
    },
    methods: {
        async init() {
            this.loading = false;
            this.form = initAttendanceCode(this.value);

            if (!this.isCreate) {
                this.loading = true;
                try {
                    const { code } = await api.v1.company.attendance.codes.get({ _id: this.value?._id });
                    this.$emit("input", code);
                    this.form = initAttendanceCode(code);
                } finally {
                    this.loading = false;
                }
            }
        },

        async save() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { ...form } = this.form;
                let { post, put } = api.v1.company.attendance.codes;
                let { code } = await (this.isCreate ? post : put)(form);

                this.form = initAttendanceCode(code);
                this.$emit("input", code);
                this.$emit("search");
                alert(this.isCreate ? "생성되었습니다" : "수정되었습니다");
                this.shows = false;
            } finally {
                this.loading = false;
            }
        },

        emit() {
            this.form = initAttendanceCode(this.form);
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .text-right input {
        text-align: right;
    }
    .v-input--switch label {
        margin-bottom: 4px;
    }
    .v-textarea textarea {
        margin: 0 !important;
        padding-top: 8px;
        line-height: 1.875em;
    }
}
</style>
